<script lang="ts" setup>
import { toast } from "vue-sonner";

definePageMeta({
  layout: "center-layout",
});

const { fetch: refreshSession, openInPopup } = useUserSession();
const redirectPath = computed(() => {
  const queryRedirect = useRoute().query.redirect as string | undefined;
  // Check if redirect path is login or empty, default to home
  if (!queryRedirect || queryRedirect.includes("/login")) {
    return "/";
  }
  return queryRedirect;
});

async function loginWithGoogle() {
  openInPopup("/api/auth/google", {
    width: 400,
    height: 600,
  });

  // Handle the message from the popup
  window.addEventListener(
    "message",
    async (event) => {
      if (event.origin !== window.location.origin) return;

      if (event.data.type === "auth-success") {
        // Refresh the session
        await refreshSession();

        // Navigate to the redirect path
        return navigateTo({
          path: redirectPath.value,
          query: {
            toastMessage: "Login Successful, redirecting to home page...",
            toastType: "success",
          },
        });
      } else if (event.data.type === "auth-error") {
        toast.error(`Login Failed, ${event.data.message}`);
        return;
      }
    },
    { once: true },
  ); // Remove listener after first use
}
</script>

<template>
  <div class="w-full h-full">
    <div class="absolute m-4">
      <!-- logo xurya  -->
      <NuxtImg
        src="https://storage.googleapis.com/xurya-app-files/onm-suite-web/logo/xurya-logo-white.png"
        class="w-[30%]"
        alt="Logo Xurya White"
      />
    </div>

    <div class="h-full w-full flex items-center text-center text-white">
      <div class="w-full">
        <h1 class="text-center text-3xl font-bold m-auto">Halaman ini memerlukan autentikasi</h1>
        <h2 class="text-center text-lg m-2 italic">
          Silahkan klik tombol login dibawah untuk mengakses Xurya ONM Suite
        </h2>
        <div class="text-center m-4">
          <Button
            variant="ghost"
            class="py-2 px-4 text-sm border border-solid border-primary text-primary rounded-sm hover:bg-primary hover:text-white font-semibold hover:cursor-pointer"
            @click="loginWithGoogle"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24">
              <path
                fill="currentColor"
                d="M3.064 7.51A10 10 0 0 1 12 2c2.695 0 4.959.991 6.69 2.605l-2.867 2.868C14.786 6.482 13.468 5.977 12 5.977c-2.605 0-4.81 1.76-5.595 4.123c-.2.6-.314 1.24-.314 1.9s.114 1.3.314 1.9c.786 2.364 2.99 4.123 5.595 4.123c1.345 0 2.49-.355 3.386-.955a4.6 4.6 0 0 0 1.996-3.018H12v-3.868h9.418c.118.654.182 1.336.182 2.045c0 3.046-1.09 5.61-2.982 7.35C16.964 21.105 14.7 22 12 22A9.996 9.996 0 0 1 2 12c0-1.614.386-3.14 1.064-4.49"
              />
            </svg>
            Login dengan Google
          </Button>
        </div>
      </div>
    </div>
  </div>
</template>
